import { LocalStorageKeys } from 'lib/types/localStorageTypes'
import logger from './logger'

// Always bump the version when you made changes in any of the stored stores
const LOCAL_STORAGE_VERSION = '1.0'

const version = localStorage.getItem(LocalStorageKeys.version)

// version check on Init
if (version !== LOCAL_STORAGE_VERSION) {
  // reset the session info and localStorage
  logger.info('Version check of local storage is changed. The session would have been invalidated')
}
